module.exports = __webpack_public_path__ + "img/rijtjeshuis.c79350db.png";